import { Tag } from "antd";

export default function PayuPaymentStatus({value} : {value: string}) {
    const mapping: { [index: string]: {color: string, value: string} } = {
        PENDING: {
            color: "success",
            value: "Rozpoczęto"
        },
        WAITING_FOR_CONFIMRATION: {
            color: "processing",
            value: "Oczekiwanie na potwierdzenie"
        },
        COMPLETED: {
            color: "green",
            value: "Zakończono"
        },
        CANCELED: {
            color: "error",
            value: "Anulowano"
        }
    };

    const result = mapping[value];

    if (!result) {
        return "-";
    }

    return <Tag style={{ fontSize: 12 }} color={result.color}>{result.value}</Tag>;
}